const ASSIGNED_PERMISSIONS = 'assignedPermissions'

export function setAssignedPermissions(assignedPermissions) {
  localStorage.setItem(ASSIGNED_PERMISSIONS, assignedPermissions);
}

export function clearAssignedPermissions() {
  localStorage.removeItem(ASSIGNED_PERMISSIONS);
}

export function checkPermission(checkedPermission) {
  let permissions = localStorage.getItem(ASSIGNED_PERMISSIONS);

  if (!permissions) {
    return false;
  }

  let found = permissions.split(',').find((permission) => {
    return permission === checkedPermission;
  })

  return found ? true : false;
}

export function permissionByProfileType(profileType, role){
  return 'VacanciesCandidates' + profileType + role;
}
